exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-37f5e83c]{margin-left:15px;margin-right:15px}label input[data-v-37f5e83c]{margin-right:5px}ul[data-v-37f5e83c]{margin-top:.5rem;margin-bottom:0}ul li[data-v-37f5e83c]{display:block;font-size:14px}.red[data-v-37f5e83c]{color:#dc3545;margin:0}.green[data-v-37f5e83c]{color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37f5e83c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/common/ss_hostname.vue
// module id = oOzq
// module chunks = 0